import { render, staticRenderFns } from "./step-manufacturer.vue?vue&type=template&id=67791b97&scoped=true&"
import script from "./step-manufacturer.vue?vue&type=script&lang=js&"
export * from "./step-manufacturer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67791b97",
  null
  
)

export default component.exports